import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHaptic: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconHaptic"><Path d="M2.75 9.25C4.31231 9.25 5.84891 6.75 7.375 6.75C8.9222 6.75 10.4586 9.25 12 9.25C13.5315 9.25 15.068 6.75 16.625 6.75C18.1424 6.75 19.6793 9.25 21.25 9.25M2.75 17.25C4.31231 17.25 5.84891 14.75 7.375 14.75C8.9222 14.75 10.4586 17.25 12 17.25C13.5315 17.25 15.068 14.75 16.625 14.75C18.1424 14.75 19.6793 17.25 21.25 17.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
});

export default IconHaptic;
